<template>
    <div class="page-content">
        <div class="banner" style="background-image: url(assets/images/itinerary_banner.png)">
            <div class="banner__navigation">
                <a href="">Back</a>

                <div class="banner__icons">
                    <div class="like" v-on:click="isLiked = !isLiked">
                        <i class="like-icon"
                            v-bind:class="{ liked: isLiked }"></i>
                    </div>

                    <div class="share dropdown-container">
                        <i class="share-icon dropdown-trigger"></i>

                        <div class="dropdown share-dropdown hidden">
                            <div class="row">Copy link</div>
                            <div class="row">Download as PDF</div>
                            <div class="row">Send a copy to my email</div>
                            <div class="row">Share on social media</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="itinerary-details">
                <div class="country">Canada</div>
                <h1 class="itinerary__title">Experience Canada</h1>
                <div class="itinerary__desc">Trip To Iqaluit In Nunavut A Canadian Arctic City</div>
            </div>

            <router-link  class="itinerary-owner"
                v-bind:to="{ name: 'Profile' }">
                <img src="assets/images/avatar1.png" class="avatar" alt="Camelia Jenssen's avatar" />

                <div class="itinerary-owner__details">
                    <div class="itinerary-owner__name">Camelia Jenssen</div>
                    <div class="itinerary-owner__rank">PlanIt Top Blogger, Rank 13</div>
                </div>
            </router-link>
        </div>

        <div class="section">
            <h2>Itinerary Overview</h2>
            <p>We keep a vitrual diary of your trips for you to share and reminisce.</p>

            <div class="timeline-row">
                <TimelineItem v-for="n in 10" v-bind:key="n"></TimelineItem>
            </div>
        </div>

        <div class="section itinerary-day">
            <h2>Day 1 – March 15, 2018</h2>

            <div class="activity-list">
                <ActivityItem v-for="n in 3" v-bind:key="n"></ActivityItem>
            </div>
        </div>

        <div class="section comments">
            <h2>Comments</h2>

            <form>
                <img src="assets/images/avatar1.png" alt="User Avatar" class="avatar" />
                <input type="text" placeholder="Write a comment" />
            </form>

            <div class="comments-list">
                <CommentItem v-for="n in 2" v-bind:key="n"></CommentItem>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ItineraryDisplay',
        components: {
            TimelineItem: require('./timelineItem').default,
            ActivityItem: require('./activityItem').default,
            CommentItem: require('./commentItem').default
        },
        data: function() {
            return {
                isLiked: false
            }
        },
        beforeCreate: function() {
            let body = document.querySelector('body')
            body.dataset.page = 'itinerary'
        },
        methods: {
            resizeTimelineContainer: function() {
                let timelineContainer = document.querySelector('.timeline-row')
                let timelineItems = timelineContainer.querySelectorAll('.timeline-item')
                let timelineItemsLength = timelineItems.length

                if (timelineItemsLength > 4) {
                    let newHeight = 0
                    let itemLength = Math.ceil(timelineItemsLength / 2)

                    for (let i = 0; i < itemLength; i++) {
                        let marginTop = parseInt(window
                            .getComputedStyle(timelineItems[i])
                            .getPropertyValue('margin-top'))
                        newHeight += marginTop + timelineItems[i].clientHeight
                    }

                    timelineItems[itemLength - 1].classList.add('no-line')
                    timelineContainer.style.height = `${newHeight}px`
                }
            }
        },
        mounted: function() {
            if (window.innerWidth >= 780) {
                this.resizeTimelineContainer()
            }

            let dropdownTriggers = document.querySelectorAll('.dropdown-trigger')

            dropdownTriggers.forEach(dropdownTrigger => dropdownTrigger.addEventListener('click', () => {
                let dropdown = dropdownTrigger.closest('.dropdown-container')
                    .querySelector('.dropdown')
                dropdown.classList.toggle('hidden')
            }))
        }
    }
</script>

<style scoped lang="scss">
    .banner {
        position: relative;
        display: grid;
        padding: 65px 24px 15px;
        width: 100%;
        min-height: calc(100vw / 1440 * 677);
        color: #FFF;

        @media all and (max-width: $breakpoint) {
            padding: 65px 15px 20px;
        }
    }

    .banner::before {
        content: "";
        background-color: rgba(#000, 0.5);
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }


    .banner > * {
        position: relative;
    }


    .banner__navigation {
        display: flex;
        justify-content: space-between;
        position: absolute;
        top: 64px + 37px;
        left: 0;
        right: 0;
        margin: 0 auto;
        max-width: 1265px;
        width: calc(100% - (24px * 2));

        @media all and (max-width: 870px) {
            align-items: center;
            position: relative;
            top: unset;
            left: unset;
            right: unset;
            margin: 0;
            width: 100%;
        }
    }


    .banner__navigation a {
        font-size: 20px;
        color: rgba(#FFF, 0.8);

        @media all and (max-width: $breakpoint) {
            font-size: 14px;
        }
    }


    .banner__icons {
        display: flex;
    }


    .banner__icons .share {
        margin-left: 34px;

        @media all and (max-width: $breakpoint) {
            margin-left: 16px;
        }
    }


    .like-icon,
    .share-icon {
        opacity: 0.7951;
        cursor: pointer;

        @media all and (min-width: $breakpoint + 1) {
            width: 36px;
            height: 36px;
        }

        @media all and (max-width: $breakpoint) {
            width: 24px;
            height: 24px;
        }
    }

    .like-icon {
        margin-right: 5px;
    }


    .share-dropdown {
        background-color: #FFF;
        right: 0;
        color: $navy;
        z-index: 3;
    }


    .share-dropdown .row {
        display: flex;
        align-items: center;
        padding: 0 25px;
        height: 36px;
        white-space: nowrap;
        font-weight: $medium;
        font-size: 12px;
        cursor: pointer;
    }

    .share-dropdown .row:not(:first-child) {
        margin-top: 2px;
    }

    .share-dropdown .row:not(:last-child):not(:nth-last-child(2)) {
        box-shadow: 0 1px 1px #F5F5F5;
    }

    .share-dropdown .row:last-child {
        background-color: #ECECEC;
    }





    .itinerary-details {
        margin: auto;
        text-align: center;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    .country {
        text-transform: uppercase;
        font-weight: $medium;
        font-size: 20px;
        letter-spacing: 5px;

        @media all and (max-width: $breakpoint) {
            font-size: 14px;
        }
    }


    .itinerary__title {

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 20px;
            font-size: 48px;
        }

        @media all and (max-width: $breakpoint) {
            font-size: 20px;
        }
    }


    .itinerary__desc {

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 16px;
            font-size: 20px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 5px;
            font-size: 14px;
        }
    }


    .itinerary-owner {
        display: flex;
        align-items: center;
        margin: 0 auto;
        color: inherit;

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    .itinerary-owner .avatar {

        @media all and (min-width: $breakpoint + 1) {
            width: 65px;
            height: 65px;
        }

        @media all and (max-width: $breakpoint) {
            width: 24px;
            height: 24px;
        }
    }


    .itinerary-owner__details {
        margin-left: 15px;

        @media all and (max-width: $breakpoint) {
            margin-left: 10px;
        }
    }


    .itinerary-owner__name {
        font-weight: $heavy;
        font-size: 18px;
        color: $accent;

        @media all and (max-width: $breakpoint) {
            font-size: 12px;
        }
    }


    .itinerary-owner__rank {
        font-size: 14px;

        @media all and (max-width: $breakpoint) {
            font-size: 10px;
        }
    }


    .timeline-row {
        position: relative;
        display: flex;
        align-items: center;
        flex-direction: column;
        flex-wrap: wrap;
        margin: 3px auto 0;
        max-width: 940px;
        overflow: hidden;
    }


    .itinerary-day {
        margin: 54px auto 0;
        padding: 0 15px;
        max-width: calc(940px + (15px * 2));

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
        }
    }


    .itinerary-day h2 {
        text-align: left;
    }


    .section.comments {
        margin-left: auto;
        margin-right: auto;
        padding: 0 15px;
        width: 100%;
        max-width: calc(940px + (15px * 2));
    }


    .comments h2 {
        text-align: left;
        font-family: inherit;
        font-weight: $medium;
        font-size: 20px;

        @media all and (max-width: $breakpoint) {
            font-size: 16px;
        }
    }


    .comments form {
        position: relative;
        margin-top: 27px;

        @media all and (max-width: $breakpoint) {
            margin-top: 15px;
        }
    }


    .comments .avatar {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto 0;

        @media all and (min-width: $breakpoint + 1) {
            left: 34px;
            width: 48px;
            height: 48px;
        }

        @media all and (max-width: $breakpoint) {
            left: 15px;
            width: 36px;
            height: 36px;
        }
    }


    .comments [type="text"] {
        padding: 0 15px 0 100px;
        width: 100%;
        font-weight: $book;
        font-size: inherit;
        border: 1px solid $light-gray;

        @media all and (min-width: $breakpoint + 1) {
            height: 88px;
            line-height: 88px;
        }

        @media all and (max-width: $breakpoint) {
            padding-left: 36px + (15px * 2);
            height: 60px;
            line-height: 60px;
        }
    }
</style>
